module.exports = __webpack_public_path__ + "static/img/b470e04.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/xczx/img/swipe_03.png
// module id = 702
// module chunks = 2